import { useEffect, useRef, forwardRef, useCallback } from "react";
import { FaEllipsisH } from "react-icons/fa";

const FlagDropDown = forwardRef(({
  rowId,
  activeMenuRow,
  setActiveMenuRow,
  list,
  onChangeHandler
}, forwardedRef) => {
  const dropdownRef = useRef(null);
  const iconWrapperRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      iconWrapperRef.current &&
      !iconWrapperRef.current.contains(event.target)
    ) {
      setActiveMenuRow(null);
    }
  }, [setActiveMenuRow]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  const toggleMenu = () => {
    setActiveMenuRow(activeMenuRow === rowId ? null : rowId);
  };

  return (
    <div ref={forwardedRef} style={{ position: "relative" }}>
      <span ref={iconWrapperRef} style={{ display: "inline-flex" }}>
        <FaEllipsisH
          onClick={toggleMenu}
          style={{ cursor: "pointer", fontSize: "18px" }}
        />
      </span>

      {activeMenuRow === rowId && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            top: "25px",
            right: 0,
            background: "var(--color-surface-muted)",
            border: "1px solid var(--color-border-strong)",
            borderRadius: "6px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            padding: "8px 0",
            minWidth: "160px"
          }}
        >
          {Array.isArray(list) &&
            list.map((item, idx) => (
              <div
                key={idx}
                onClick={() => onChangeHandler(item.id, rowId)}
                style={{
                  padding: "10px 16px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  color: "var(--color-text)",
                  transition: "background 0.2s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "var(--color-link-soft)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
              >
                {item.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
});

export default FlagDropDown;
